    /// <reference path="../interfaces/lightsliderconfig.ts" />
module Tapas.ViewModels {
    export class CartViewModel extends Ftw.ViewModels.BaseViewModel {
        public Cart = Ftw.Core.InstanceManager.get<Ftw.Dto.Cart>('Cart');
        public CartDataService = new Ftw.Dataservice.CartDataserviceDynamicweb;
        public CartLoading = ko.observable(false);
        public CheckoutPageId = ko.observable(0);
        public CartHtml = ko.observable("");
        public CartTotal = ko.observable("");
        public CartState = ko.observable("notVisible"); //empty //populated
        public CartHtmlDefined: KnockoutComputed<boolean>;
        public data = new Ftw.Data();
        public timeout;
        public EmptyCartStatus = ko.observable('');

        constructor() {
            super();

            this.CartHtmlDefined = ko.computed({
                owner: this,
                read: () => {
                    return this.CartHtml() == "" ? false : true;
                }
            });
        }
        
        public gtmOrderDataLayer() {
            setTimeout(function() {
                var orderData = document.getElementById("orderlines").dataset.orderInfo;
                orderData = JSON.parse(orderData);
                var orderId = orderData[0];
                var orderCurrency = orderData[1];
                var orderTotalPrice = orderData[2];
            
                var productDataDivs = $("#orderlines .cart-orderline");
                var items = [];
                
                productDataDivs.each(function() {
                    var productDataAttr = $(this).attr("data-product-info");
                    var productData = JSON.parse(productDataAttr);
                    var name = productData[0];
                    var id = productData[1];
                    var country = productData[2];
                    var beforePrice = productData[3];
                    var beforePriceVat = (beforePrice/100)*25;
                    var beforePriceWithVat = beforePrice + beforePriceVat;
                    var price = productData[4];
                    var currency = productData[5];
                    var brand = productData[6];
                    var primaryGroup = productData[7];
                    var quantity = productData[8];

                    price = price.replace(",", ".");
                    var priceParsed = parseFloat(price);
                    var quantityParsed = parseInt(quantity);
    
                    items.push({
                        item_name: name,
                        item_id: id,
                        affiliation: country,
                        discount: beforePriceWithVat,
                        price: priceParsed,
                        item_brand: brand,
                        item_category: primaryGroup,
                        //item_list_name: '[item list name]',
                        //item_list_id: '[item list id]',
                        //item_variant: '[item variant]',
                        //location_id: '[location_id]',
                        //index: '[index number]',
                        quantity: quantityParsed,
                        currency: currency
                    })
                });
                
                console.log("Show cart", items);
                
                var windowAny = (window as any);
                windowAny.dataLayer.push({ ecommerce: null });
                windowAny.dataLayer.push({
                    event: 'view_cart',
                    ecommerce: {
                        currency: orderCurrency,
                        value: orderTotalPrice,
                        items: items
                    }
                });
            }, 2000);
        }

        public GetCurrentFromModule = () => {
            var cartObject = this.Cart();
            if (this.CheckoutPageId() != 0) {
                var data = {
                    ID: this.CheckoutPageId(),
                    LayoutTemplate: "Designs/Tapas/ajax_page.cshtml",
                    ajaxTapas: true
                };
                this.data.postForm("Default.aspx", data)
                    .then((data) => {
                        if (cartObject.TotalProductQuantity() == 0) {
                            this.CartState("empty");
                        } else {
                            // We maybe need to reverse the minicart order RSH 23-05-16
                            // Here we put the products in a array and reverse them
                            //var dataReversed = $($(data).find(".orderline").get().reverse());
                            //console.log(dataReversed);
                            this.CartState("populated");
                            this.CartHtml($(data).find(".js-lines").html());
                            this.CartTotal($(data).find(".js-total").html());
                            ko.applyBindings(this, document.getElementById("orderlines"));
                        }
                    })
                    .finally(() => {
                        this.CartLoading(false);
                    });
            }
            else {
                this.CartLoading(false);
            }
        }

        public AddProduct = (data, event: Event) => {            
            var _target = $(event.target);
            var quantity = parseInt(_target.attr("ftw-quantity"));
            var productId = _target.attr("ftw-productid");
            var comment = _target.attr("ftw-comment");   
            var variantId = _target.attr("ftw-variantId");
           
            if (productId != '') {

                this.CartLoading(true);
                //Ex p� at added noget med et custom order linje felt der har systemnavnet "Comment"
                //this.CartDataService.AddProduct({ productId, quantity, orderLineFields: [{ systemName: 'Comment', value: 'Dette er en kommentar' }] })
                this.CartDataService.AddProduct({ productId: productId, quantity : quantity, variantId: variantId })
                    .finally(() => {
                        this.CartLoading(false);
                    });
            }
        }

        public AddProductOnSubmit = (data, event: Event) => {            
            var quantity = parseInt(data.getAttribute("ftw-quantity"));
            var productId = data.getAttribute("ftw-productid"); 
            var variantId = data.getAttribute("ftw-variantid"); 
            if (productId != '') {
                this.CartLoading(true);
                this.CartDataService.AddProduct({ productId: productId, quantity: quantity, variantId: variantId })
                    .finally(() => {
                        this.CartLoading(false);
                    });
            }
        }

        public AddProductFromProductViewModel = (vm: Tapas.ViewModels.ProductViewModel, event: Event) => {
            this.CartLoading(true);
            this.CartDataService.AddProduct({ productId: vm.ProductId(), quantity: vm.Quantity(), variantId: vm.VariantId(), orderLineFields: [{ systemName: 'Comment', value: vm.Comment() }] }) 
                .finally(() => {
                    this.CartLoading(false);
                });
            
            console.log(event.target);
            var productData;
            var _target = $(event.target);
            if (!_target.hasClass("add-to-cart-list")) {
                productData = document.getElementById("product-view-details").dataset.productInfo;
                console.log("is detail", productData)
            } else {
                // Productlist specific
                productData = _target.attr("data-product-info");
                console.log("is list", productData)
            }
            
            productData = JSON.parse(productData);
            var name = productData[0];
            var id = productData[1];
            var country = productData[2];
            var saving = productData[3];
            var beforePriceVat = (saving/100)*25;
            var beforePriceWithVat = saving + beforePriceVat;
            var priceWithCurrency = productData[4];
            var brand = productData[5];
            var primaryGroup = productData[6];

            var priceSplit = priceWithCurrency.split(" ");
            var priceWithoutCurrency = priceSplit[0];
            var currency = priceSplit[1];
            var eventType = "add_to_cart";

            console.log("Add to cart", productData);
            
            var windowAny = (window as any);
            windowAny.dataLayer.push({ ecommerce: null });
            windowAny.dataLayer.push({
                event: eventType,
                ecommerce: {
                    items: [{
                        item_name: name,
                        item_id: id,
                        affiliation: country,
                        discount: beforePriceWithVat,
                        price: priceWithoutCurrency,
                        item_brand: brand,
                        item_category: primaryGroup,
                        //item_list_name: '[item list name]',
                        //item_list_id: '[item list id]',
                        //item_variant: '[item variant]',
                        //location_id: '[location_id]',
                        //index: '[index number]',
                        quantity: '1',
                        currency: currency
                    }]
                }
            });
        }

        public UpdateQuantity = (data, event: Event) => {
            clearTimeout(this.timeout);
            var _target = $(event.target);
            var orderLineId = _target.attr("ftw-olid");
            var quantity = parseInt(_target.val());
            if (quantity === 0) {
                this.DeleteOrderLine(data, event);
                return;
            }

            this.timeout = setTimeout(() => {
                this.CartLoading(true);
                this.CartDataService.UpdateCartLineQuantity(orderLineId, quantity)
                .then(() => {
                    this.GetCurrentFromModule();
                })
                .fail(() => {
                    this.CartLoading(false);
                });
            }, 1000);
        }

        //public DeleteOrderLine = (data, event: Event, name, id, country, saving, priceWithCurrency, brand, primaryGroup) => {
        //public DeleteOrderLine = (name, id, country, saving, priceWithCurrency, brand, primaryGroup, data, event: Event) => {
        public DeleteOrderLine = (data, event: Event) => {
            var _target = $(event.target);
            var orderLineId = _target.attr("ftw-olid");

            // Google Datalayer
            var cartOrderline;
            var productData
            
            if (!_target.hasClass("miniCart")) {
                cartOrderline = _target.closest(".cart-orderline");
                productData = cartOrderline.attr("data-product-info");
                console.log("Not minicart", productData);
                productData = JSON.parse(productData);
            } else {
                // Minicart specific
                cartOrderline = _target.closest(".orderline");
                var productDataAttr = cartOrderline.find(".product-info").attr("data-product-info");
                productData = productDataAttr.split(",");
                console.log("Minicart", productData);
            }
            
            var name = productData[0];
            var id = productData[1];
            var country = productData[2];
            var beforePrice = productData[3];
            var beforePriceVat = (beforePrice/100)*25;
            var beforePriceWithVat = beforePrice + beforePriceVat;
            var priceWithCurrency = productData[4];
            var brand = productData[5];
            var primaryGroup = productData[6];

            var priceSplit = priceWithCurrency.split(" ");
            var priceWithoutCurrency = priceSplit[0];
            var currency = priceSplit[1];
            var eventType = "remove_from_cart";

            console.log("Delete", name, id, country, beforePriceWithVat, priceWithoutCurrency, brand, primaryGroup);

            var windowAny = (window as any);
            windowAny.dataLayer.push({ ecommerce: null });
            windowAny.dataLayer.push({
                event: eventType,
                ecommerce: {
                    items: [{
                        item_name: name,
                        item_id: id,
                        affiliation: country,
                        discount: beforePriceWithVat,
                        price: priceWithoutCurrency,
                        item_brand: brand,
                        item_category: primaryGroup,
                        //item_list_name: '[item list name]',
                        //item_list_id: '[item list id]',
                        //item_variant: '[item variant]',
                        //location_id: '[location_id]',
                        //index: '[index number]',
                        quantity: '1',
                        currency: currency
                    }]
                }
            });

            this.CartLoading(true);

            this.CartDataService.DeleteCartLine(orderLineId)
                .then((result) => {
                    this.GetCurrentFromModule();
                }).fail(() => {
                this.CartLoading(false);
            });
        }

        public ConfirmEmptyCart = () => {
            this.EmptyCartStatus('confirmation');
        }

        public EmptyCart = () => {
            this.CartLoading(true);
            this.CartDataService.EmptyCart()
            .then((result) => {
                this.GetCurrentFromModule();
            }).fail(() => {
                this.CartLoading(false);
            });
        }
    }
}